const HIDDEN_PERFORMANCE_GESTIONNAIRE_IDS: string[] = ['250', '260'];

const HIDDEN_PERFORMANCE_GESTIONNAIRE_LABELS: string[] = ['La France Mutualiste', 'AG2R La Mondiale'];

export { HIDDEN_PERFORMANCE_GESTIONNAIRE_IDS, HIDDEN_PERFORMANCE_GESTIONNAIRE_LABELS };
